module.exports = __webpack_public_path__ + "img/BonusGame_2208x1242_10.1acf27ea.png";